export default __webpack_public_path__ + "static/rr-6287c19840797e79849de20e2687aa4d.png";